var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "row" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 text-center contact-header" }, [
        _vm._v("\n      ติดต่อเรา\n    ")
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 text-center mt-4" }, [
        _c(
          "a",
          {
            staticStyle: { margin: "1rem" },
            attrs: {
              href: "https://line.me/R/ti/p/%40hnk7011n",
              target: "_blank"
            },
            on: {
              click: function($event) {
                return _vm.trackLineEvent("Contact Line")
              }
            }
          },
          [
            _c("img", {
              attrs: {
                height: "38",
                alt: "Line BeNeat",
                src: "/static/img/btn-line.png"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticStyle: { margin: "1rem" },
            attrs: {
              href: "https://www.messenger.com/t/beneatco/",
              target: "_blank"
            },
            on: {
              click: function($event) {
                return _vm.trackLineEvent("Contact FB msg")
              }
            }
          },
          [
            _c("img", {
              attrs: {
                height: "38",
                alt: "FB Messenger BeNeat",
                src: "/static/img/btn-fb-messenger.png"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 text-center mt-4" }, [
        _c(
          "a",
          {
            staticStyle: { margin: "1rem" },
            attrs: {
              href: "https://line.me/R/ti/p/%40hnk7011n",
              target: "_blank"
            },
            on: {
              click: function($event) {
                return _vm.trackLineEvent("Contact Line")
              }
            }
          },
          [
            _c("img", {
              attrs: {
                height: "38",
                alt: "Line BeNeat",
                src: "/static/img/btn-line.png"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticStyle: { margin: "1rem" },
            attrs: {
              href: "https://www.messenger.com/t/beneatco/",
              target: "_blank"
            },
            on: {
              click: function($event) {
                return _vm.trackLineEvent("Contact FB msg")
              }
            }
          },
          [
            _c("img", {
              attrs: {
                height: "38",
                alt: "FB Messenger BeNeat",
                src: "/static/img/btn-fb-messenger.png"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm._m(5),
      _vm._v(" "),
      _vm._m(6)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 text-center" }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: "/static/img/general-infomation01.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 text-center contact-content mt-2" },
      [
        _c("i", { staticClass: "fas fa-phone" }),
        _vm._v(" 02-113-1138   "),
        _c("span", { staticStyle: { "font-style": "italic" } }, [
          _vm._v("www.BeNeat.co")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 text-center" }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: "/static/img/general-infomation02.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 text-center contact-header mt-4" },
      [
        _vm._v("\n      ติดต่อเรา\n      "),
        _c("div", { staticClass: "separator" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 text-center contact-content mt-2" },
      [
        _c("i", { staticClass: "fas fa-phone" }),
        _vm._v(" 02-113-1138   "),
        _c("span", { staticStyle: { "font-style": "italic" } }, [
          _vm._v("www.BeNeat.co")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-12 text-center contact-header",
        staticStyle: { "margin-top": "4rem" }
      },
      [
        _vm._v("\n      Download Application\n      "),
        _c("div", { staticClass: "separator" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-12 text-center",
        staticStyle: { margin: "1rem 0 4rem 0" }
      },
      [
        _c(
          "a",
          {
            staticStyle: { margin: "0 1rem" },
            attrs: {
              href: "https://itunes.apple.com/th/app/beneat/id1203611695?mt=8",
              target: "_blank"
            }
          },
          [
            _c("img", {
              attrs: {
                height: "62",
                alt: "BeNeat iOS App",
                src: "/static/img/btn-app-store.svg"
              }
            })
          ]
        ),
        _vm._v(" \n      "),
        _c(
          "a",
          {
            staticStyle: { margin: "0 1rem" },
            attrs: {
              href:
                "https://play.google.com/store/apps/details?id=com.beneat.app",
              target: "_blank"
            }
          },
          [
            _c("img", {
              attrs: {
                height: "62",
                alt: "BeNeat Android App",
                src: "/static/img/btn-play-store.svg"
              }
            })
          ]
        )
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-409beb97", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-409beb97","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/GeneralInformation.vue
// module id = 1624
// module chunks = 0